import React, { Component } from 'react';
import { Button, Popconfirm, message, Tooltip, Icon } from 'antd';
import PropTypes from 'prop-types';
import TableC from '../../basicElement/TableC';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import FundsFilter from './components/FundsFilter';
import ExportFixedLine from './components/ExportFixedLine';
import FundsUpdate from './components/FundsUpdate';
import { FundsOperationLog, PreviewModal } from './components/OperationLog';
import ConfigColumn from './ConfigColumn';
import format from '../../shared/format';
import renderEnhancer from '../../shared/renderEnhancer';
import cellRenderEnhancer, { beforeChangeEnhancer } from '../../shared/cellRenderEnhancer';
import ProgressModal from './components/ProgressModal';
import UpdateARplan from './components/UpdateARplan';
import UpdateLog from './components/UpdateLog';

class FundsFollowTable extends Component {

    static childContextTypes = {
        configure: PropTypes.object,
    }

    state = {
        data: [],
        loading: false,
        sortParams: {},
        searchParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
        configure:{},
        tableHeader:[],
        
    }
    openChildList = (investigationId,index)=>{
        const {data , pagination , searchParams} = this.state;
        const { accountDistribute } = searchParams
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryRemittanceTraceRecordDetail,
            data: {investigationId ,accountDistribute},
            dataType: 'json',
            doneResult: res => {
                const  record =res.data;
                pagination.total=pagination.total+(Math.ceil(pagination.total/pagination.pageSize))*record.length;
                pagination.pageSize=pagination.pageSize+record.length;
                data[index].openChildList = true;
                data.splice( index + 1, 0, ...record )
                let newData = [...data]
                this.setState({
                    data: newData, 
                    pagination,
                })
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
        
    }
    cloceChildList = (investigationId,index)=>{
        const {data , pagination , searchParams} = this.state;
        const { accountDistribute } = searchParams
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryRemittanceTraceRecordDetail,
            data: {investigationId , accountDistribute},
            dataType: 'json',
            doneResult: res => {
                const  record =res.data;
                pagination.total=pagination.total-(Math.ceil(pagination.total/pagination.pageSize))*record.length;
                pagination.pageSize=pagination.pageSize-record.length;
                data[index].openChildList=false;
                data.splice(index+1,record.length)
                let newData = [...data]
                this.setState({data:newData,pagination})
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
        
    }

    configColumn = ()=>{
        return this.configColumnRef.show()
    }

    getChildContext = () => {
        const { configure } = this.state;
        return {
            configure,
        };
    }

    componentDidMount() {
        this.getHeader()
        // this.queryInvestigationStageByInvId();
        this.getCoTraceConfigure();
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.status && this.props.status) {
            this.loadData();
        }
    }

    loadData = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const params = this.splitParams(searchParams);
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryRemittanceTraceList,
            data: {
                offset: current,
                limit: 10,
                ...sortParams,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                pagination.pageSize = 10;
                datas.forEach(item => item.openChildList = false)
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    delete = (majorEventId) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.execute.delMajorEvent,
            data: { majorEventId },
            dataType: 'json',
            doneResult: res => {
                const { success } = res;
                message.success(success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    update = (type, record) => {
        this.setState({
            type,
            record,
        }, () => {
            !type && this.loadData();
        });
    }

    export = () => {
        const { sortParams, searchParams } = this.state;
        const params = this.splitParams(searchParams);
        Fetch.post(API_URL.investigation.exportRemittanceTraceList, { ...sortParams, ...params })
        .then(res => {
            message.success(res.success);
        }).catch(error => {
            console.error(error);
        });
    }

    queryInvestigationStageByInvId = () => {
        const { invId: investigationId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    invStageList: data,
                });
            },
        };
        $.sendRequest(options);
    }

    getCoTraceConfigure = () => {
        const options = {
            method: 'POST',
            url: API_URL.investigation.getCoTraceConfigure,
            data: { },
            dataType: 'json',
            doneResult: res => {
                const { configureList = [] } = res;
                const REMITTANCE_POSSIBILITY =  configureList && configureList.filter(item=>item.typeName == 'REMITTANCE_POSSIBILITY');
                const KEY_BLOCKING_TYPE =  configureList && configureList.filter(item=>item.typeName == 'KEY_BLOCKING_TYPE');
                this.setState({
                    configure: {
                        REMITTANCE_POSSIBILITY,
                        KEY_BLOCKING_TYPE,
                    },
                });
            }
        };
        $.sendRequest(options);
    }


    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    filterDate = (text) => text ? text.slice(0, 10) : '';

    handleStringLinefeed = (text) => {
        const arr = (text || '').split('；');
        const result = arr.map((item, index) => {
            return <span key={index}>{item}{index < arr.length - 1 ? ';' : ''}<br /></span>;
        });
        return result;
    }

    getHeader=()=>{
        const options = {
            method: 'POST',
            url: API_URL.common.queryUserCustomDisplayByUserId,
            data: { type:'REMITTANCE_TRACE'},
            dataType: 'json',
            doneResult: data => {
                const headers = data.REMITTANCE_TRACE;
                const tableHeader = [];
                headers.forEach(head => {
                    if (head.isShow !== "0") {
                        tableHeader.push(head);
                    }
                });
                this.setState({ tableHeader:this.getColumns(tableHeader) },()=>{
                    this.loadData();
                });
            }
        };
        
        $.sendRequest(options);
    }


    getColumns = (tableHeadercolumn) => {
        const operation={
            title: <Icon onClick={this.configColumn} type="setting" style={{fontSize: "18px",display:'block',textAlign:'center'}} />,
            dataIndex: 'operation',
            key: 'operation',
            width: 50,
            fixed: 'left',
            align: 'center',
            render: (text, record, index) => {
                const {openChildList ,investigationId} = record;
                if( openChildList == undefined ) {
                    return null
                }else {
                    return (
                        <span style={{display:'block',textAlign:'center'}}>
                            <Icon 
                                type={ openChildList ? 'minus-square-o' : 'plus-square-o'} 
                                onClick={() => openChildList ? 
                                    this.cloceChildList(investigationId,index) : 
                                    this.openChildList(investigationId,index)
                                }
                            />
                        </span>
                    )
                }
                
            }
        }
        const creditColumns = this.getCreditColumns()
        const columns = [{
            title: '更新日期',
            dataIndex: 'modifyTime',
            key: 'modifyTime',
            width: 100,
            fixed:'left',
            render: this.filterDate,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 180,
            fixed:'left',
        },{
            title: 'JDE主项目号',
            dataIndex: 'jdeMainCode',
            key: 'jdeMainCode',
            width: 100,
            fixed:'left',
        },{
            title: 'JDE项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            width: 100,
            render: text => text?text:'-'
        },{
            title: '项目类型',
            dataIndex: 'investigationGlobalTypeShow',
            key: 'investigationGlobalTypeShow',
            width: 120,
        },{
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineNames',
            key: 'secondLineNames',
            width: 120,
        }, {
            title: '项目分期',
            dataIndex: 'byStageNames',
            key: 'byStageNames',
            width: 100,
        },  {
            title: '项目分类',
            dataIndex: 'invTypeName', 
            key: 'invTypeName',
            width: 160,
        }, {
            title: '计收入确认方式',
            dataIndex: 'contractTypeValue',
            key: 'contractTypeValue',
            width: 120,
        },{
            title: 'PM',
            dataIndex: 'pmNameCodes',
            key: 'pmNameCodes',
            width: 120,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {pmNameCodes } = record;
                        const pmNameCodesList = pmNameCodes?pmNameCodes.split(','):[]
                        if ((pmNameCodesList || []).length > 1) {
                            return (
                                <div>
                                    {
                                        pmNameCodesList.map((value,index) => (
                                            <div key={index}>
                                                {value} 
                                            </div>
                                        ))
                                    }
                                </div>
                            );
                        }
                    }
                })(text => text?text.split(',')[0]:'')
            ),
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 120,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 80,
        }, {
            title: '领域leader',
            dataIndex: 'areaLeaderNameCodes',
            key: 'areaLeaderNameCodes',
            width: 120,
        }, {
            title: 'PML（包含大区总监）',
            dataIndex: 'pmlNameCodes',
            key: 'pmlNameCodes',
            width: 120,
        }, {
            title: 'BD',
            dataIndex: 'bdNameCodes',
            key: 'bdNameCodes',
            width: 150,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {bdNameCodes } = record;
                        const bdNameCodesList = bdNameCodes?bdNameCodes.split(','):[]
                        if ((bdNameCodesList || []).length > 1) {
                            return (
                                <div>
                                    {
                                        bdNameCodesList.map((value,index) => (
                                            <div key={index}>
                                                {value} 
                                            </div>
                                        ))
                                    }
                                </div>
                            );
                        }
                    }
                })(text => text?text.split(',')[0]:'')
            ),
        }, {
            title: 'CSA',
            dataIndex: 'csaNameCode',
            key: 'csaNameCode',
            width: 150,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {csaNameCode } = record;
                        const CSANameCodesList = csaNameCode?csaNameCode.split(','):[]
                        if ((CSANameCodesList || []).length > 1) {
                            return (
                                <div>
                                    {
                                        CSANameCodesList.map((value,index) => (
                                            <div key={index}>
                                                {value} 
                                            </div>
                                        ))
                                    }
                                </div>
                            );
                        }
                    }
                })(text => text?text.split(',')[0]:'')
            ),
        },{
            title: '客户名称',
            dataIndex: 'customerCompanyName',
            key: 'customerCompanyName',
            width: 150,
        },{
            title: '客户JDE号',
            dataIndex: 'customerCompanyCode',
            key: 'customerCompanyCode',
            width: 150,
        }, {
            title: '合同额/人民币（元）',
            dataIndex: 'contractAmount',
            key: 'contractAmount',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '最终应回款合同额/人民币（元）',
            dataIndex: 'finalReturnAmount',
            key: 'finalReturnAmount',
            width: 120,
            render: text => format('money', text),
        }, {
            title: '请款规则',
            dataIndex: 'eventType',
            key: 'eventType',
            width: 100,
            render: (text, record) => {
                return (
                    <a onClick={()=> this.viewCloumeDetail({...record, modalTitle: '请款规则'},'rule')}>查看详情</a>
                )
            }
        }, {
            title: '累计已开票金额/人民币（元）',
            dataIndex: 'totalInvoiceAmount',
            key: 'totalInvoiceAmount',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '累计回款金额/人民币（元）',
            dataIndex: 'totalReturnAmount',
            key: 'totalReturnAmount',
            width: 100,
            render: text => format('money', text),
        }, {
            title: (
                <span>
                    累计回款比例
                    <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'累计回款金额/合同额/(人民币)元'}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'totalReturnPercent',
            key: 'totalReturnPercent',
            width: 100,
        }, {
            title: (
                <span>
                    已确认收入比例
                    <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'累计收入不含税/合同额不含税'}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>
            ),
            dataIndex: 'confirmIncomePercent',
            key: 'confirmIncomePercent',
            width: 80,
        },{
            title: '累计请款开票比例',
            dataIndex: 'totalInvoicePercent',
            key: 'totalInvoicePercent',
            width: 100,
        }, {
            title: '当前可请款节点', 
            dataIndex: 'reportToPmLmDate12345',
            key: 'reportToPmLmDate12345',
            width: 120,
            render: (text, record) => {
                return (
                    <a onClick={()=> this.viewCloumeDetail({...record, modalTitle: '当前可请款节点'},'node')}>查看详情</a>
                )
            }
        }, {
            title: '当月预计应开票金额/人民币（元）',
            dataIndex: 'thisMonthPredictInvoiceAmount',
            key: 'thisMonthPredictInvoiceAmount',
            width: 120,
            render: text => format('money', text),
        },{
            title: '当月已开票金额/人民币（元）',
            dataIndex: 'thisMonthInvoiceAmount',
            key: 'thisMonthInvoiceAmount',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '下一笔请款预计日期',
            dataIndex: 'nextRemittanceDate',
            key: 'nextRemittanceDate',
            width: 160,
            render: this.filterDate,
        }, {
            title: '下一笔请款金额/人民币（元）',
            dataIndex: 'nextRemittanceAmount',
            key: 'nextRemittanceAmount',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '下月开票可能性判断',
            dataIndex: 'nextInvoicePossibility',
            key: 'nextInvoicePossibility',
            width: 120,
        }, {
            title: '下月预计开票金额不含税/人民币（元）',
            dataIndex: 'nextMonthPredictInvoiceAmount',
            key: 'nextMonthPredictInvoiceAmount',
            width: 80,
            render: text => format('money', text),
        }, {
            title: 'PM填写更新请款进度',
            dataIndex: 'remittanceProcess',
            key: 'remittanceProcess',
            width: 140,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                    const {remittanceProcess } = record;
                        if((remittanceProcess || []).length > 20){
                            return (
                                <div>{remittanceProcess}</div>
                            );
                        }
                    }
                })(text => text?text.substring(0,20):'')
            ),
        }, {
            title: '更新请款进度',
            dataIndex: 'investigationMedicineTypeShow', 
            key: 'investigationMedicineTypeShow',
            width: 100,
            render: (text, record) => {
                return (
                    <a onClick={()=> this.viewCloumeDetail({...record, modalTitle: '更新请款进度'}, 'baprocess')}>查看详情</a>
                )
            }
        }, {
            title: '当前卡脖子节点负责人',
            dataIndex: 'keyBlocking',
            key: 'keyBlocking',
            width: 100,
        },{
            title: '津石PM',
            dataIndex: 'pmNameCode',
            key: 'pmNameCode',
            width: 100,
        },{
            title: '负责人CSA',
            dataIndex: 'baNameCodeList',
            key: 'baNameCodeList',
            width: 120,
        },{
            title: 'CSA卡脖子节点',
            dataIndex: 'baStopComment',
            key: 'baStopComment',
            width: 100,
        },...creditColumns];
        let result=[operation]
        tableHeadercolumn.forEach(item => {
            const { isShow, dataIndex } = item;
            if (isShow === '1' || showAll) {
                const column = columns.find(i => i.dataIndex === dataIndex) || {};
                if(column.title){
                    result.push(column);
                }
            }
        });
        result.push({
            title: '操作',
            dataIndex: 'operate',
            key: 'operate',
            fixed: 'right',
            width: 120,
            render: (text, record) => {
                const { showUpdate,investigationJdeContractCode } = record || {}; 
                return !investigationJdeContractCode?(
                    <span>
                        {
                            showUpdate == 1 && <span>
                                <a onClick={() => this.update('edit', record)}>更新</a>
                                <span className="ant-divider" />
                            </span>
                        }
                        <a onClick={() => this.viewDetail(record)}>更新日志</a>
                    </span>
                ):<span>
                    <a onClick={() => this.updateARplanRef.show(record)}>更新AR计划</a>
                    <span className="ant-divider" />
                    <a onClick={() => this.updateLogRef.show(record)}>更新日志</a>
                </span>
            }
        })
        return result;
    }
    getCreditColumns = () =>{
        const credit = [
            {
                title:'已确认收入未开票',
                type:'cl',
                key:'accountsReceivableCl',
                dataIndex:'accountsReceivableCl'
            },
            {
                title:'已开票未收款',
                type:'empty',
                key:'accountsReceivableEmpty',
                dataIndex:'accountsReceivableEmpty'
            }]
        const columns = []
        credit.forEach((item,index)=>{
            columns.push({
                title:item.title,
                key:item.key,
                dataIndex:item.dataIndex,
                children:[{
                    title: "信用期内",
                    dataIndex: "forFuture",
                    key: "forFuture"+index,
                    width: 100,
                    render: (text ,row) => row[item.type]?format('money', row[item.type].forFuture):''
                },
                {
                    title: "31天以内（逾期）",
                    dataIndex: "less31",
                    key: "less31"+index,
                    width: 100,
                    render: (text ,row) => row[item.type]?format('money', row[item.type].less31):''

                },
                {
                    title: "31~60天（逾期）",
                    dataIndex: "day31To60",
                    key: "day31To60"+index,
                    width: 100,
                    render: (text ,row) => row[item.type]?format('money', row[item.type].day31To60):''

                },
                {
                    title: "61~90天（逾期）",
                    dataIndex: "day61To90",
                    key: "day61To90"+index,
                    width: 100,
                    render: (text ,row) => row[item.type]?format('money', row[item.type].day61To90):''

                },
                {
                    title: "91~120天（逾期）",
                    dataIndex: "day91To120",
                    key: "day91To120"+index,
                    width: 100,
                    render: (text ,row) => row[item.type]?format('money', row[item.type].day91To120):''

                },
                {
                    title: "121~150天（逾期）",
                    dataIndex: "day121To150",
                    key: "day121To150"+index,
                    width: 100,
                    render: (text ,row) => row[item.type]?format('money', row[item.type].day121To150):''

                },
                {
                    title: "151~180天（逾期）",
                    dataIndex: "day151To180",
                    key: "day151To180"+index,
                    width: 100,
                    render: (text ,row) => row[item.type]?format('money', row[item.type].day151To180):''

                },
                {
                    title: "181~365天（逾期）",
                    dataIndex: "day181To365",
                    key: "day181To365"+index,
                    width: 100,
                    render: (text ,row) => row[item.type]?format('money', row[item.type].day181To365):''

                },
                {
                    title: "366~730天（逾期）",
                    dataIndex: "day366To730",
                    key: "day366To730"+index,
                    width: 100,
                    render: (text ,row) => row[item.type]?format('money', row[item.type].day366To730):''

                },
                {
                    title: '731~1095天（逾期）',
                    dataIndex: 'day731To1095',
                    key: 'day731To1095'+index,
                    width: 100,
                    render: (text ,row) => row[item.type]?format('money', row[item.type].day731To1095):''

                },
                {
                    title: "1095天以上（逾期）",
                    dataIndex: "great1095",
                    key: "great1095"+index,
                    width: 100,
                    render: (text ,row) => row[item.type]?format('money', row[item.type].great1095):''

                },
                {
                    title: "120天以上合计",
                    dataIndex: "sumGreat120",
                    key: "sumGreat120"+index,
                    width: 100,
                    render: (text ,row) => row[item.type]?format('money', row[item.type].sumGreat120):''

                },
                {
                    title: "365天以上合计",
                    dataIndex: "sumGreat365",
                    key: "sumGreat365"+index,
                    width: 100,
                    render: (text ,row) => row[item.type]?format('money', row[item.type].sumGreat365):''

                },
                {
                    title: "所有金额合计",
                    dataIndex: "amount",
                    key: "amount"+index,
                    width: 100,
                    render: (text ,row) => row[item.type]?format('money', row[item.type].amount):''

                },
                {
                    title: item.key === 'accountsReceivableCl' ? '请款进度详情' : '回款进度详情',
                    dataIndex: "paymentProgress",
                    key: "paymentProgress"+index,
                    width: 100,
                    render: (text, row) => <a onClick={() => this.progressModalRef.show(row, item.key)}>查看详情</a>
                },
                {
                    title: "行动计划",
                    dataIndex: "actionPlan",
                    key: "actionPlan"+index,
                    width: 100,
                    render: (text ,row) => row[item.type]?row[item.type].actionPlan:''
                },
                {
                    title: "预计完成时间",
                    dataIndex: "estimatedCompletionTimeStr",
                    key: "estimatedCompletionTimeStr"+index,
                    width: 100,
                    render: (text ,row) => row[item.type]?row[item.type].estimatedCompletionTimeStr:''
                },
                {
                    title: "下一环节责任人",
                    dataIndex: "nextNodeManager",
                    key: "nextNodeManager"+index,
                    width: 100,
                    render: (text ,row) => row[item.type]?row[item.type].nextNodeManager:''
                },]
            })
        })
        return columns
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    viewDetail = (record) => {
        this.operationLogRef.show(record);
    }
    
    viewCloumeDetail = (record, type) => {
        this.previewModalRef.show(record, type);
    }

    showFixedLine = () => {
        this.exportFixedLineRef.show(API_URL.investigation.exportRemittanceTraceRecordList);
    }

    render() {
        const { config } = this.props;
        const { data, loading, pagination, searchParams, sortParams, type, record ,tableHeader } = this.state;
        const { siteId, curRole, investigationSiteName } = sessionStorage;
        const isPM = curRole === 'PM';
        const isCRC = curRole === 'CRC';
        const isInProject = !!investigationSiteName;
        const isSingleSite = siteId > 0;
        const canEdit = isInProject && ((!isSingleSite && isPM) || (isSingleSite && (isPM || isCRC)));
        const scrollY = (document.body || document.documentElement).clientHeight - 300;
        return (
            <div>
                {
                    !type ?  <div >
                  <FundsFilter
                      config={config}
                      search={this.search}
                      params={searchParams}
                      onChange={this.handleFilterChange}
                      buttons={[
                          <Button key="export" type="primary" onClick={this.export}>导出</Button>,
                          <Button onClick={this.showFixedLine} className="btn-yellow">导出固化数据</Button>
                      ]}
                  />
                  <TableC
                      data={data}
                      scrollY={scrollY}
                      loading={loading}
                      sortParams={sortParams}
                      columns={tableHeader}
                      rowKey="index"
                      pagination={pagination}
                      onChange={this.handleTableChange}
                  />
              </div>
              : <div >
              <FundsUpdate
                type={type}
                record={record}
                update={this.update}
                viewCloumeDetail={this.viewCloumeDetail.bind(this)}
             />
            </div>
                }
                <ExportFixedLine ref={el => this.exportFixedLineRef = el} />
                <FundsOperationLog ref={el => this.operationLogRef = el}/>
                <PreviewModal ref={el => this.previewModalRef = el} />
                <ConfigColumn ref={el => this.configColumnRef = el} loadData={this.getHeader} />
                <ProgressModal ref={el => this.progressModalRef = el}/>
                <UpdateARplan ref={el => this.updateARplanRef = el} loadData={this.getHeader}/>
                <UpdateLog ref={el => this.updateLogRef = el}/>
            </div>
           
        );
    }
}

export default FundsFollowTable;


// WEBPACK FOOTER //
// ./src/components/contractManagement/coFollowFunds/FundsFollowTable.js